/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable arrow-parens */
import { API, Auth } from 'aws-amplify'
import qs from 'qs'
import { DateUtils } from '@aws-amplify/core'
const apiName = 'tripshaAPI'
DateUtils.setClockOffset(100 * 1000 * -1)

const APIWrapper = async (method, url, params = {}) => {
  try {
    const session = await Auth.currentSession()
    if (!session.isValid()) {
      throw new Error('Invalid session');
    }
    return API[method](apiName, url, params)
  } catch (err) {
    if (err === 'No current user' || err.message === 'Invalid session') {
      window.location.href = '/login'
    }
    throw err;
  }
}

const AuthAPIWrapper = async (method, url, params = {}) => {
  try {
    const session = await Auth.currentSession();
    if (!session.isValid()) throw new Error('Invalid session');

    // --- Let Amplify handle IAM signing ---
    // The library will automatically sign the request with the user's credentials.
    const myInit = {
      // Body is for POST/PUT, params is for GET
      ...(method === 'get' ? { queryStringParameters: params } : { body: params }),
      // NO "headers" object here. Amplify adds the complex IAM signature.
    };
    return API[method](apiName, url, myInit);
  } catch (err) {
    if (err === 'No current user' || err.message === 'Invalid session') {
      window.location.href = '/login';
    }
    throw err;
  }
};
// export const getUserProfile = async (queryParams) =>
//   APIWrapper('get', `/public/profile?${qs.stringify(queryParams)}`)
export const getInterest = () => API.get(apiName, `/public/trip-tags?limit=500`)
export const getUserProfile = (queryParams) => API.get(apiName, `/public/profile?${qs.stringify(queryParams)}`)
export const getTrip = (tripId) => API.get(apiName, `/public/trips/${tripId}`)
export const getCountry = () => API.get(apiName, `/public/countries?limit=500`)
export const getCurrencies = () => API.get(apiName, `/public/currency-exchange`)
export const checkUserExistsPublic = (params) => API.get(apiName, `/public/check-user-exists?${qs.stringify(params)}`)
export const checkUserRegisteredForEvent = (params) => API.get(apiName, `/public/check-user-registered-for-event?${qs.stringify(params)}`)
export const getTripList = (queryParams) => API.get(apiName, `/public/trips?${queryParams}`)

export const getTripBookings = (tripId) =>
  APIWrapper('get', `/trips/${tripId}/booking`)
export const getPrivateTrip = (tripId, queryParams) =>
  APIWrapper('get', `/trips/${tripId}?${qs.stringify(queryParams)}`)
export const getAllPrivateTripList = (queryParams) =>
  APIWrapper('get', `/trips?${queryParams}`)
export const getCohosts = (id) => APIWrapper('get', `/trips/${id}/co-hosts`)
export const addCohosts = (id, param) =>
  APIWrapper('post', `/trips/${id}/co-hosts`, {
    body: param,
  })
export const deleteCohosts = (id, param) =>
  APIWrapper('del', `/trips/${id}/co-hosts`, {
    body: param,
  })
export const transferHosts = (id, param) =>
  APIWrapper('post', `/trips/${id}/transfer-host`, {
    body: param,
  })
export const transferTripOrganization = (tripId, organizationId) =>
  APIWrapper('put', `/trips/${tripId}/transfer-organization`, {
    body: { organizationId },
  })
export const getUserByEmailORUsername = (params) =>
  APIWrapper('get', `/users/get-user?${qs.stringify(params)}`)

export const getPrivateTripList = (params) =>
  APIWrapper('get', `/trips/mytrips?${qs.stringify(params)}`)

export const tripPagination = () =>
  APIWrapper('get', '/trips/mytrips/?page=0&limit=5')

export const getUsers = (queryParams) =>
  APIWrapper('get', `/users?${queryParams}`)

export const inviteUser = (user) =>
  APIWrapper('post', `/users/invite`, {
    body: user,
  })
export const updateAdminUser = (id, user) =>
  APIWrapper('put', `/admin/users/${id}`, {
    body: user,
  })
export const adminUserAction = (user) =>
  APIWrapper('post', `/admin/users/action`, {
    body: user,
  })

export const getApprovals = (queryParams) =>
  APIWrapper('get', `/approvals?${queryParams}`)

export const getAssets = (queryParams = '') =>
  APIWrapper('get', `/assets?${qs.stringify(queryParams)}`)

export const createAsset = (asset) =>
  APIWrapper('post', `/assets`, { body: asset })

export const updateAsset = (id, asset) =>
  APIWrapper('put', `/assets/${id}`, { body: asset })

export const deleteAsset = (ids) =>
  APIWrapper('del', `/assets`, { body: { asset_ids: ids } })

export const updateAssets = (params) =>
  APIWrapper('post', `/assets/bulk-action`, { body: params })

export const getCouponCodes = (queryParams = '') =>
  APIWrapper('get', `/coupons?${qs.stringify(queryParams)}`)

export const getSelectedTrips = (couponId) =>
  APIWrapper('get', `/coupons/${couponId}/trips`)

export const getSelectedHosts = (couponId) =>
  APIWrapper('get', `/coupons/${couponId}/hosts`)

export const deleteCouponCode = (id) => APIWrapper('del', `/coupons/${id}`)

export const createCouponCode = (coupon) =>
  APIWrapper('post', `/coupons`, { body: coupon })

export const applyCouponCode = (coupon) =>
  APIWrapper('post', `/coupons/apply`, { body: coupon })

export const updateCouponCode = (id, coupon) =>
  APIWrapper('put', `/coupons/${id}`, { body: coupon })

export const listMembers = (queryParams = '') =>
  APIWrapper('get', `/directory-members?${qs.stringify(queryParams)}`)

export const createMembers = (members) =>
  APIWrapper('post', `/directory-members`, { body: members })
export const deleteMembers = (members) =>
  APIWrapper('del', `/directory-members`, { body: members })

export const createApproval = (approval) =>
  APIWrapper('post', `/approvals`, {
    body: approval,
  })

export const approvalAction = (id, approval) =>
  APIWrapper('put', `/approvals/${id}`, {
    body: approval,
  })

export const getUserByUsername = async (userId) =>
  APIWrapper('get', `/users/username/${userId}`)

export const createUser = (user) =>
  APIWrapper('post', '/users', {
    body: user,
  })

export const createUserPublic = (user) =>
  API.post(apiName, '/public/users', {
    body: user,
  })

export const createTrip = (trip) =>
  APIWrapper('post', '/trips', {
    body: trip,
  })

export const updateTrip = (tripId, trip) =>
  APIWrapper('put', `/trips/${tripId}`, {
    body: trip,
  })

export const claimVenueSpot = (tripId, variantId, action) =>
  APIWrapper('post', `/trips/${tripId}/venue-claim`, {
    body: { variantId, action },
  })

export const submittedActivityLogsTabInformation = (body) =>
  APIWrapper('post', '/activity-logs-tab/submitted', { body: body })

export const acceptedActivityLogsTabInfromation = (body) =>
  APIWrapper('post', "/activity-logs-tab/accepted", { body: body })

export const withdrewActivityLogsTabInfromation = (body) =>
  APIWrapper('post', "/activity-logs-tab/withdrew", { body: body })

export const cancelledActivityLogsTabInfromation = (body) =>
  APIWrapper('post', "/activity-logs-tab/cancelled", { body: body })

export const paidActivityLogsTabInfromation = (body) =>
  APIWrapper('post', "/activity-logs-tab/paid", { body: body })

export const searchActivityLogsTabInformation = (userId, tripId) =>
  APIWrapper('get', `/activity-logs-tab/search/${userId}/${tripId}`)

export const addGuestListActivityLogsTabInformation = (body) =>
  APIWrapper('post', '/activity-logs-tab/add-to-guest-list', { body: body });

export const removeGuestListActivityLogsTabInformation = (body) =>
  APIWrapper('post', '/activity-logs-tab/remove-from-guest-list', { body: body });

export const getSavedTrips = (params) =>
  APIWrapper('get', `/trips/saved-trips?${qs.stringify(params)}`)

export const getActivityLogs = (params) =>
  APIWrapper('get', `/activities?${qs.stringify(params)}`)

export const getTripMembers = (tripId) =>
  APIWrapper('get', `/trips/${tripId}/members`)

export const getYourTrips = () => APIWrapper('get', '/trips/mytrips')

export const makeAction = (trip) =>
  APIWrapper('post', '/members/action', {
    body: trip,
  })

export const searchMembersList = (params) =>
  APIWrapper('get', `/users/search-users/${params}`)

export const fetchConversationsList = (queryParams) => {
  const params = {
    sortBy: 'updatedAt',
    sortOrder: -1,
    ...queryParams,
  }
  return APIWrapper('get', `/conversations?${qs.stringify(params)}`)
}
export const fetchConversationMessages = ({ userId, tripId, isGroup }) =>
  APIWrapper(
    'get',
    `/conversations/messages?memberId=${userId}&tripId=${tripId}&sortBy=updatedAt&isGroup=${isGroup}`,
  )

export const getThemes = () => APIWrapper('get', '/trip-tags')

export const subscribeUser = (params) =>
  APIWrapper('post', '/users/subscribe', {
    body: params,
  })

export const createCardIntent = () => APIWrapper('get', '/payments/setup')

export const saveCard = (params) =>
  APIWrapper('post', '/payments/save-card', {
    body: params,
  })

export const chargeCard = (params) =>
  APIWrapper('post', '/payments/charge', {
    body: params,
  })

export const updateCurrentUser = (params, userId = 'me') =>
  APIWrapper('put', `/users/${userId}`, {
    body: params,
  })


export const verifyConnectAccount = (params) =>
  APIWrapper('post', '/payments/connect-oauth', {
    body: params,
  })

export const listCards = () => APIWrapper('get', '/payments/list-cards')
export const deleteCardAPI = (id) =>
  APIWrapper('del', `/payments/delete-card/${id}`)
export const createBooking = (params) =>
  APIWrapper('post', '/bookings', {
    body: params,
  })

// Public booking API endpoint does not exist on server
// export const createBookingPublic = (params) =>
//   API.post(apiName, '/public/bookings', {
//     body: params,
//   })

export const hostRegisterUserEndPoint = (params) =>
  APIWrapper('post', '/bookings/hostRegisterUser', { body: params })

export const fetchTripBookings = (tripId) =>
  APIWrapper('get', `/bookings/host?tripId=${tripId}`)

export const updateTripBookings = (params) =>
  APIWrapper('put', `/bookings`, { body: params })

export const getInvites = (tripId) =>
  APIWrapper('get', `/bookings/${tripId}/invites`)

export const respondInvite = (tripId, params) =>
  APIWrapper('post', `/bookings/${tripId}/invites`, { body: params })

export const updateCustomFields = (bookingId, params) =>
  APIWrapper('put', `/bookings/${bookingId}/custom-fields`, { body: params })

export const updateGuestFields = (bookingId, params) =>
  APIWrapper('put', `/bookings/${bookingId}/guest-fields`, { body: params })

export const getBookingRequest = (bookingId) =>
  AuthAPIWrapper('get', `/bookings/${bookingId}`)

export const requestAction = (bookingId, params) =>
  APIWrapper('post', `/bookings/${bookingId}/action`, {
    body: params,
  })

export const memberInvite = (params) =>
  APIWrapper('post', `/bookings/invite`, {
    body: params,
  })

export const removeInviteAPI = (params) =>
  APIWrapper('del', `/bookings/invite`, {
    body: params,
  })

export const inviteApi = (params) =>
  APIWrapper('post', `/bookings/invite/resend`, {
    body: params,
  })
export const sendCustomEmailApi = (params) =>
  APIWrapper('post', `/bookings/invite/custom-email`, {
    body: params,
  })

export const fetchBookingRequests = (params) =>
  APIWrapper('get', `/bookings?${qs.stringify(params)}`)

// Public booking check API does not exist on server
// export const fetchBookingRequestsPublic = (params) =>
//   API.get(apiName, `/public/bookings?${qs.stringify(params)}`)

export const fetchUserData = (awsUserId) =>
  APIWrapper('get', `/users/${awsUserId}`)

export const fetchBookingBalance = (bookingID, cardDetails) =>
  APIWrapper('post', `/bookings/${bookingID}/payment`, { body: cardDetails })

export const rejectBooking = (id) =>
  APIWrapper('put', `/bookings/${id}`, {
    body: { status: 'rejected' },
  })

export const updateBooking = (id, params) =>
  APIWrapper('put', `/bookings/${id}`, {
    body: params,
  })

export const hostRequest = (params) =>
  APIWrapper('post', '/host-requests', {
    body: params,
  })
export const getMembersWithBooking = (tripId) =>
  APIWrapper('get', `/trips/${tripId}/members?isHost=true&includeBooking=true`)
export const sendMessagePost = (params) =>
  APIWrapper('post', '/conversations/send-message', {
    body: params,
  })

export const updateHostRequest = (hostRequestId, params) =>
  APIWrapper('put', `/host-requests/${hostRequestId}`, { body: params })

export const deleteTrip = (tripId, params = {}) =>
  APIWrapper('del', `/trips/${tripId}`, {
    body: params,
  })

export const cancelTrip = (tripId, params = {}) =>
  APIWrapper('del', `/trips/${tripId}/cancel`, {
    body: params,
  })

export const restoreTrip = (tripId, params = {}) =>
  APIWrapper('put', `/trips/${tripId}/restore`, {
    body: params,
  })

export const getHostRequest = (params) =>
  APIWrapper('get', `/host-requests?${qs.stringify(params)}`)

export const getActiveRequest = (tripId) =>
  APIWrapper('get', `/bookings?tripId=${tripId}&isHost=true`)

export const getStripeAuthUrl = (
  accountType = 'standard',
  redirect_uri = false,
  state = false,
) => {
  let url = false
  if (accountType === 'standard') {
    url = `https://dashboard.stripe.com/oauth/authorize?response_type=code&client_id=${process.env.REACT_APP_STRIPE_CLIENT_ID}&scope=read_write`
  }
  if (accountType === 'express') {
    url = `https://dashboard.stripe.com/express/oauth/authorize?response_type=code&client_id=${process.env.REACT_APP_STRIPE_CLIENT_ID}&scope=read_write`
  }
  if (url && state) {
    url = `${url}&state=${state}`
  }
  if (url && redirect_uri) {
    url = `${url}&redirect_uri=${redirect_uri}`
  }
  return url
}
export const checkUserExists = (params) =>
  APIWrapper('post', '/users/check-user-exists', {
    body: params,
  })

// Payments
export const createPayment = (params) =>
  APIWrapper('post', `/host-payments`, {
    body: params,
  })
export const listPayments = (params) =>
  APIWrapper('get', `/host-payments?${qs.stringify(params)}`)

export const updatePayment = (id, params) =>
  APIWrapper('put', `/host-payments/${id}`, {
    body: params,
  })

export const deletePayments = (params) =>
  APIWrapper('del', `/host-payments`, {
    body: params,
  })

export const convertTokenPrice = (params) =>
  APIWrapper('post', `/crypto/convert-token-units`, {
    body: params,
  })

export const getNextSpendAllowanceNonce = (params) =>
  APIWrapper(
    'get',
    `/crypto/next-spend-nonce/${params.chainId}/${params.token}/${params.address}`,
  )

export const getOrgEmailBranding = (orgId) =>
  API.get(apiName, `/public/organizations/${orgId}/email-branding`)

export const updateOrgEmailBranding = (orgId, data) =>
  APIWrapper('put', `/organizations/${orgId}/email-branding`, { body: data })

export const listOrgEmailTemplates = (orgId) =>
  APIWrapper('get', `/organizations/${orgId}/email-templates`)

export const createOrgEmailTemplate = (orgId, data) =>
  APIWrapper('post', `/organizations/${orgId}/email-templates`, { body: data })

export const updateOrgEmailTemplate = (orgId, templateId, data) =>
  APIWrapper('put', `/organizations/${orgId}/email-templates/${templateId}`, { body: data })

export const deleteOrgEmailTemplate = (orgId, templateId) =>
  APIWrapper('delete', `/organizations/${orgId}/email-templates/${templateId}`)

export const APIS = {
  createProject: (body) =>
    APIWrapper('post', `/trips/project`, {
      body,
    }),
  editProject: (id, body) =>
    APIWrapper('put', `/trips/project/${id}`, {
      body,
    }),
  saveDraftTrip: (id, body) =>
    APIWrapper('put', `/trips/${id}/draft`, {
      body,
    }),
  publishTrip: (id, body) =>
    APIWrapper('put', `/trips/${id}/publish`, {
      body,
    }),
  unPublishTrip: (id, body) =>
    APIWrapper('put', `/trips/${id}/unpublish`, {
      body,
    }),
  activeProjects: (params) => API.get(apiName, `/trips/active-trips?${qs.stringify(params)}`),
  getCurrentUser: (params = {}) =>
    APIWrapper('get', `/users/me?${qs.stringify(params)}`),
  listResources: (params) =>
    APIWrapper('get', `/resources?${qs.stringify(params)}`),
  createResource: (body) =>
    APIWrapper('post', `/resources`, {
      body: body,
    }),
  assignResources: (body) =>
    APIWrapper('post', `/resources/assign`, {
      body: body,
    }),
  unassignResources: (body) =>
    APIWrapper('post', `/resources/unassign`, {
      body: body,
    }),
  editResource: (resourceId, body) =>
    APIWrapper('put', `/resources/${resourceId}`, {
      body: body,
    }),
  editCollection: (collectionId, body) => {
    APIWrapper('put', `/resources/collection/${collectionId}`, {
      body: body,
    })
  },
  deleteCollection: (collectionId) =>
    APIWrapper('del', `/resources/collection/${collectionId}`),
  deleteResources: (body) =>
    APIWrapper('del', `/resources`, {
      body: body,
    }),
  listPermissions: (params) =>
    APIWrapper('get', `/permissions/user?${qs.stringify(params)}`),
  createPermissions: (body) =>
    APIWrapper('post', `/permissions/user`, {
      body: body,
    }),
  deletePermissions: (body) =>
    APIWrapper('del', `/permissions/user`, {
      body: body,
    }),
  listGroupPermissions: (params) =>
    APIWrapper('get', `/permissions/group?${qs.stringify(params)}`),
  createGroupPermissions: (body) =>
    APIWrapper('post', `/permissions/group`, {
      body: body,
    }),
  deleteGroupPermissions: (body) =>
    APIWrapper('del', `/permissions/group`, {
      body: body,
    }),
  listLinks: (params) => APIWrapper('get', `/links?${qs.stringify(params)}`),
  createLink: (body) =>
    APIWrapper('post', `/links`, {
      body: body,
    }),
  editLink: (linkId, body) =>
    APIWrapper('put', `/links/${linkId}`, {
      body: body,
    }),
  deleteLinks: (linkIds) =>
    APIWrapper('del', `/links`, {
      body: linkIds,
    }),
  listAdminTrips: (params) =>
    APIWrapper('get', `/admin/trips?${qs.stringify(params)}`),
  getPermissionsByUserId: (params) =>
    APIWrapper('get', `/permissions/${params}`),
  listAdminOrganization: (params) =>
    APIWrapper('get', `/admin/organizations?${qs.stringify(params)}`),
  updateAdminOrganization: (id, body) =>
    APIWrapper('put', `/admin/organizations/${id}`, { body }),
  unbilledPayments: (params) =>
    APIWrapper('get', `/billing/unbilled-payment?${qs.stringify(params)}`),
  invoices: (params) =>
    APIWrapper('get', `/billing/invoices?${qs.stringify(params)}`),
  getInvoice: (invoiceId) =>
    APIWrapper('get', `/billing/invoices/${invoiceId}`),
  getInvitedTrips: () => APIWrapper('get', `/trips/invited`),
  getTopics: (params) => APIWrapper('get', `/topics?${qs.stringify(params)}`),
  getMessages: (topicId) => APIWrapper('get', `/topics/${topicId}/messages`),
  createTopic: (body) =>
    APIWrapper('post', `/topics`, {
      body,
    }),
  editTopic: (topicId, body) =>
    APIWrapper('put', `/topics/${topicId}`, {
      body,
    }),
  deleteTopic: (topicId) => APIWrapper('del', `/topics/${topicId}`),
  createMessage: (topicId, body) =>
    APIWrapper('post', `/topics/${topicId}/messages`, {
      body,
    }),
  editMessage: (topicId, messageId, body) =>
    APIWrapper('put', `/topics/${topicId}/messages/${messageId}`, {
      body,
    }),
  deleteMessage: (topicId, messageId, body) =>
    APIWrapper('del', `/topics/${topicId}/messages/${messageId}`, {
      body,
    }),
  addGuests: (id, body) =>
    APIWrapper('post', `/bookings/${id}/add-guests`, {
      body,
    }),
  removeGuests: (id, body) =>
    APIWrapper('del', `/bookings/${id}/remove-guests`, {
      body,
    }),
  removeFromGuestList: (body) =>
    APIWrapper('post', `/bookings/remove-from-guest-list`, { body }),

  listProperties: (params) =>
    APIWrapper('get', `/properties?${qs.stringify(params)}`),
  createProperties: (body) =>
    APIWrapper('post', `/properties`, {
      body,
    }),
  updateProperties: (id, body) =>
    APIWrapper('put', `/properties/${id}`, {
      body,
    }),
  deleteProperties: (id, body) =>
    APIWrapper('del', `/properties/${id}`, {
      body,
    }),
  setActivityLogs: (body) => APIWrapper('put', `/activities`, { body }),
  listOrganizations: (params) =>
    APIWrapper('get', `/organizations?${qs.stringify(params)}`),
  getOrganization: (id, params) => API.get(apiName, `/organizations/${id}?${qs.stringify(params)}`),
  createOrganization: (body) => APIWrapper('post', `/organizations`, { body }),
  updateOrganization: (id, body) =>
    APIWrapper('put', `/organizations/${id}`, { body }),
  deleteOrganization: (id) => APIWrapper('del', `/organizations/${id}`),
  listOrganizationProjects: (id) => API.get(apiName, `/organizations/${id}/projects`),
  listOrganizationPermissions: (id) =>
    APIWrapper('get', `/organizations/${id}/permissions`),
  createOrganizationPermissions: (id, body) =>
    APIWrapper('post', `/organizations/${id}/permissions`, { body }),
  deleteOrganizationPermissions: (id, body) =>
    APIWrapper('del', `/organizations/${id}/permissions`, { body }),
}
